export function printMedicalSelfCheck(type: boolean, data: any) {
  const d = data || {};
  const base = d.baseInfo || d; 

  const yesNo = () => '是（ ） 否（ ）'

  const line = (val: any, width = 'auto', symbol = '') => 
    `<span style="display: inline-block; border-bottom: 1px solid #000; min-width: ${width}; padding: 0 4px; text-align: center;">${val || '&nbsp;'}</span>${symbol}`

  const categoryMap: Record<string, string> = {
    '1': '（一）许可情况',
    '2': '（二）人员情况',
    '3': '（三）执业情况',
    '4': '（四）传染病管理',
    '5': '（五）其他'
  };

  let html = `<div style="margin:10px; font-family: SimSun, serif; font-size: 14px; color: #000; line-height: 2.4;">`;

  // --- 标题 ---
  html += `<h2 style="text-align:center; margin-bottom:15px; font-size: 20px;">医疗机构依法执业${type ? '年度（全面）' : '季度（日常）'}自查表</h2>`;

  // --- 一、基本情况 ---
  html += `<div style="font-weight: bold; margin-bottom: 4px;">一、基本情况</div>`;
  html += `<div style="padding-left: 5px;">`;

  if (type) {
    /** * type 为 true: 保持原样 (逻辑不变)
     */
    html += `
      <div style="display: flex; justify-content: flex-start;">
        <span style="margin-right: 4px;">机构名称：<span style="display: inline-block; border-bottom: 1px solid #000; min-width: 250px; padding: 0 4px;">${base.name || ''}（盖章）</span>；</span>
        <span>机构负责人签字：${line('', '120px', '（手签）。')}</span>
      </div>
      单位地址：${line(base.address, '320px', '；')}
      <span style="margin-left: 4px;">法定代表人：${line(base.legalPerson, '100px', '；')}</span><br/>
      主要负责人：${line(base.mainPerson, '100px', '；')}
      <span style="margin-left: 4px;">联系电话：${line(base.phone, '120px', '；')}</span>
      <span style="margin-left: 4px;">邮政编码：${line(base.postcode, '100px', '；')}</span><br/>
      执业医师：${line(base.doctor, '50px', '人；')}
      <span style="margin-left:4px;">执业助理医师：${line(base.assistantDoctor, '50px', '人；')}</span>
      <span style="margin-left:4px;">护士：${line(base.nurse, '50px', '人；')}</span><br/>
      药剂人员：${line(base.pharmacist, '50px', '人；')}
      <span style="margin-left:4px;">医技检验人员：${line(base.tech, '50px', '人；')}</span>
      <span style="margin-left:4px;">核准床位数：${line(base.bed, '80px', '；')}</span><br/>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span>实际开设床位数：${line(base.realBed, '100px', '。')}</span>
        <span style="font-weight: bold; padding-right: 10px;">
          自查日期：<span style="border-bottom: 1px solid #000; min-width: 45px; display: inline-block; text-align: center;">&nbsp;</span> 年 
          <span style="border-bottom: 1px solid #000; min-width: 30px; display: inline-block; text-align: center;">&nbsp;</span> 月 
          <span style="border-bottom: 1px solid #000; min-width: 30px; display: inline-block; text-align: center;">&nbsp;</span> 日
        </span>
      </div>`;
  } else {
    /** * type 为 false: 根据图片字段重新排版 (去掉地址、邮政编码、核准床位数、实际床位)
     */
    html += `
      <div style="display: flex; justify-content: flex-start;">
        <span style="margin-right: 4px;">机构名称：<span style="display: inline-block; border-bottom: 1px solid #000; min-width: 250px; padding: 0 4px;">${base.name || ''}（盖章）</span>；</span>
        <span>机构负责人签字：${line('', '120px', '（手签）。')}</span>
      </div>
      法定代表人：${line(base.legalPerson, '100px', '；')}
      <span style="margin-left: 4px;">主要负责人：${line(base.mainPerson, '100px', '；')}</span>
      <span style="margin-left: 4px;">联系电话：${line(base.phone, '120px', '；')}</span><br/>
      执业医师：${line(base.doctor, '50px', '人；')}
      <span style="margin-left:4px;">执业助理医师：${line(base.assistantDoctor, '50px', '人；')}</span>
      <span style="margin-left:4px;">护士：${line(base.nurse, '50px', '人；')}</span><br/>
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <span>药剂人员：${line(base.pharmacist, '50px', '人；')}
          <span style="margin-left:4px;">医技检验人员：${line(base.tech, '50px', '人。')}</span>
        </span>
        <span style="font-weight: bold; padding-right: 10px;">
          自查日期：<span style="border-bottom: 1px solid #000; min-width: 45px; display: inline-block; text-align: center;">&nbsp;</span> 年 
          <span style="border-bottom: 1px solid #000; min-width: 30px; display: inline-block; text-align: center;">&nbsp;</span> 月 
          <span style="border-bottom: 1px solid #000; min-width: 30px; display: inline-block; text-align: center;">&nbsp;</span> 日
        </span>
      </div>`;
  }

  html += `</div>`; // 闭合基本情况 div

  // --- 二、检查内容 (列表部分保持不变) ---
  let globalIndex = 1;
  html += `<div style="margin-top:15px; font-weight: bold; margin-bottom: 8px;">二、检查内容</div>`;
  html += `<table style="width:100%; border-collapse:collapse; font-size:13px; text-align:center; table-layout: fixed;" border="1">
      <tbody>`;

  [1, 2, 3, 4, 5].forEach((catKey) => {
    const list = d[catKey] || [];
    html += `<tr>
      <td style="text-align:left; padding:8px; background-color: #fafafa; font-weight: bold; width:65%">
        ${categoryMap[catKey.toString()]}
      </td>
      <td style="width:11%;">有/无</td>
      <td colspan="4" style="width:24%;">相应括号内打“√”</td>
    </tr>`;

    if (list.length > 0) {
      list.forEach((item: any) => {
        html += `<tr>
          <td style="text-align:left; padding:8px;">${globalIndex}. ${item.title || ''}</td>
          <td style="width:11%;"></td>
          <td style="width:4%;">是</td>
          <td style="width:8%;">（ ）</td>
          <td style="width:4%;">否</td>
          <td style="width:8%;">（ ）</td>
        </tr>`;
        globalIndex++;
      });
    } else {
      html += `<tr><td colspan="6" style="color: #999; padding: 4px;">暂无自查数据</td></tr>`;
    }
  });

  html += `</tbody></table></div>`;
  return html;
}